export default __webpack_public_path__ + "static/media/project2.cfb6cbd6.jpeg";